import React, { Component } from 'react';

import Header from "../Header/Header"
import Welcome from "../Welcome/Welcome"
import Story from "../Story/Story"
import VideoComp from "../VideoComp/VideoComp"
import FlipPic from "../FlipPic/FlipPic"
import MakeUp from "../MakeUp/MakeUp"
import PlayBuzz from "../PlayBuzz/PlayBuzz"
import FooterBanner from "../FooterBanner/FooterBanner"
import Footer from "../Footer/Footer"

import PopupBox from "../PopupBox/PopupBox"

class App extends Component {
  constructor() {
    super();
    this.state = {
      showStory: false
    }
    this.showStory = this.showStory.bind(this);
  }
  showStory(story) {
    this.setState({
      showStory: story
    })
  }
  render() {
    return (
      <div className={`App${(this.state.showStory ? " popupActive" : "")}`}>
        <Header />
        <PopupBox showStory={this.showStory} storyData={this.state.showStory} />
        <Welcome />
        <Story showStory={this.showStory} />
        <VideoComp />
        <MakeUp />
        <FlipPic />
        <PlayBuzz item="0" />
        <FooterBanner />
        <Footer />
      </div>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/Components/App/App.js